class Aviso {
  constructor() {
    
  }
}

export default Aviso
